var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',[_c('b-form-input',{attrs:{"readonly":""},model:{value:(_vm.dataItem.pageLink),callback:function ($$v) {_vm.$set(_vm.dataItem, "pageLink", $$v)},expression:"dataItem.pageLink"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }